import {
    AddressActions,
    AddressState,
} from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import { useBFSMValue } from '../../services/hooks/useBFSMValues'
import AddressTemplate from './template'
import { Address } from '@raskrask-dk/raskrask-utils'

import * as dawaAutocomplete2 from 'dawa-autocomplete2'
import { useParams } from 'react-router'

const AddressPage = (): ReactElement => {
    const [, setAddress] = useBFSMValue<
        AddressState,
        AddressActions.Next,
        'address'
    >('address', AddressActions.Next)

    const [errorHandler, setErrorHandler] = useState({
        canSubmit: false,
        showError: false,
    })
    const [dawaAddress, setDawaAddress] = useState<Address>({
        address: '',
        geoLat: '0',
        geoLng: '0',
        zipCode: 0,
        floor: '0',
    })

    const params = useParams()

    useEffect(() => {
        dawaAutocomplete2.dawaAutocomplete(
            document.getElementById('address-field'),
            {
                select: (selected: any) => {
                    const address = selected.tekst as string
                    const geoLat = selected.data.y.toString()
                    const geoLng = selected.data.x.toString()
                    const zipCode = parseInt(selected.data.postnr) as number
                    const floor = selected.data.etage ?? '0'
                    setDawaAddress({
                        address,
                        geoLat,
                        geoLng,
                        zipCode,
                        floor,
                    })
                    setErrorHandler({ canSubmit: true, showError: false })
                },
            }
        )
    }, [])

    const onChangeAddress = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setDawaAddress({
                ...dawaAddress,
                address: e.target.value,
            })
            setErrorHandler((prev) => ({ ...prev, canSubmit: false }))
        },
        [dawaAddress]
    )

    const onSubmitAddress = useCallback(() => {
        if (errorHandler.canSubmit) {
            setAddress(dawaAddress)
        } else {
            setErrorHandler((prev) => ({ ...prev, showError: true }))
        }
    }, [dawaAddress, errorHandler.canSubmit, setAddress])

    const onKeyDownAddress = useCallback(
        (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') onSubmitAddress()
        },
        [onSubmitAddress]
    )

    return (
        <AddressTemplate
            onChangeAddress={onChangeAddress}
            onKeyDownAddress={onKeyDownAddress}
            onSubmitAddress={onSubmitAddress}
            showError={errorHandler.showError}
        />
    )
}

export default AddressPage
